export default __webpack_public_path__ + "images/f3912a9a0f5deb4473b71e3c36956bc6.svg";